var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37396 6.40779C8.50361 6.44164 7.71766 6.75214 7.29721 7.17269C7.10196 7.36799 6.78536 7.36799 6.59011 7.17274C6.39481 6.97754 6.39476 6.66094 6.59001 6.46564C7.23871 5.81684 8.29441 5.44904 9.33506 5.40854C10.3825 5.36779 11.5261 5.65459 12.3269 6.45559C12.5221 6.65084 12.5221 6.96744 12.3268 7.16269C12.1316 7.35794 11.815 7.35789 11.6197 7.16264C11.0742 6.61699 10.2375 6.37419 9.37396 6.40779Z",
    fill: "#0D7E5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4677 13.692C15.4237 12.5603 16 11.0975 16 9.5C16 5.91015 13.0898 3 9.5 3C5.91015 3 3 5.91015 3 9.5C3 13.0898 5.91015 16 9.5 16C11.0975 16 12.5603 15.4237 13.692 14.4677L13.5 15.5721L17.2568 19.329L19.329 17.2568L15.5721 13.5L14.4677 13.692ZM9.5 14.5C12.2614 14.5 14.5 12.2614 14.5 9.5C14.5 6.7386 12.2614 4.5 9.5 4.5C6.7386 4.5 4.5 6.7386 4.5 9.5C4.5 12.2614 6.7386 14.5 9.5 14.5Z",
    fill: "#0D7E5D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.964 20.0361L20.0361 17.964L20.7139 18.6419C21.0954 19.0233 21.0954 19.6418 20.7139 20.0232L20.0232 20.7139C19.6418 21.0954 19.0233 21.0954 18.6419 20.7139L17.964 20.0361Z",
    fill: "#0D7E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingIcon);
export default __webpack_public_path__ + "static/media/magnifyingIcon.d86fe52f9e138c229a71b49d3049d735.svg";
export { ForwardRef as ReactComponent };